import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { getAprName } from './lib/runtime-config.ts'

const aprName = getAprName()
document.title = aprName ? `APR ${aprName}` : 'Sistema APR'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
